export const modalReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN':
      return { ...state, [action.modal]: action.props || {} };
    case 'CLOSE': {
      const { [action.modal]: _, ...rest } = state;
      return rest;
    }
    case 'CLOSE_ALL':
      return {};
    default:
      return state;
  }
};
